import { axiosV1 } from 'interceptors/axios';
import { ApiQueryParams, Encumbrance } from 'types';

import { decryptResponse } from 'utils/token';

type GetEncumbranceProps = {
  encumbranceId: string;
  signal?: AbortSignal;
  params?: ApiQueryParams;
};

export const getEncumbrance = async ({
  encumbranceId,
  params,
  signal, // eslint-disable-line
}: GetEncumbranceProps) => {
  const { data } = await axiosV1.get(`/encumbrances/${encumbranceId}`, {
    params,
  });

  const decodedData = (await decryptResponse(data)) as Encumbrance;
  return decodedData;
};
